import React from 'react'
import GlassPanel from '../UI/GlassPanel'

/** Venues ranked by visits, plus the distinct places they sit in. */
const VenuesSection = ({ venues = [], places = [] }) => {
  if (venues.length === 0) return null

  const mostVisits = venues[0].visits

  return (
    <div className="grid gap-6 lg:grid-cols-3 mb-8">
      <GlassPanel className="p-6 lg:col-span-2">
        <h2 className="text-xl font-bold text-white mb-4">📍 Most-travelled venues</h2>

        <div className="space-y-3">
          {venues.slice(0, 8).map(venue => (
            <div key={venue.venueName}>
              <div className="flex items-baseline justify-between gap-3">
                <span className="text-white font-medium truncate">{venue.venueName}</span>
                <span className="text-sm text-gray-400 flex-shrink-0">
                  {venue.visits} {venue.visits === 1 ? 'visit' : 'visits'}
                </span>
              </div>

              {/* Bar is relative to the top venue, so the shape of the list is
                  readable without axis labels. */}
              <div className="mt-1 h-2 bg-white/10 rounded-full overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-purple-500 to-pink-500 rounded-full"
                  style={{ width: `${Math.max(6, (venue.visits / mostVisits) * 100)}%` }}
                />
              </div>

              <div className="text-xs text-gray-500 mt-1 truncate">
                {venue.place}
                {venue.years.length > 0 && ` · ${venue.years.join(', ')}`}
              </div>
            </div>
          ))}
        </div>
      </GlassPanel>

      <GlassPanel className="p-6">
        <h2 className="text-xl font-bold text-white mb-4">🌍 Places</h2>

        {places.length === 0 ? (
          <p className="text-sm text-gray-400">No locations recorded yet.</p>
        ) : (
          <div className="space-y-2">
            {places.slice(0, 10).map(place => (
              <div key={place.place} className="flex items-baseline justify-between gap-2">
                <span className="text-gray-200 truncate">{place.place}</span>
                <span className="text-sm text-gray-400 flex-shrink-0">{place.events}</span>
              </div>
            ))}
          </div>
        )}
      </GlassPanel>
    </div>
  )
}

export default VenuesSection
